import { generateEntityKey } from "@src/presentation/pages/Organizations/utils/addEditFormUtils";

export const DEDUCTION_TYPE_KEY_ALREADY_EXISTS_MESSAGE =
  "This Deduction Type Key already exists.";

const DEDUCTION_TYPE_KEY_CHARS = /[^A-Z-]/g;
const DEDUCTION_TYPE_KEY_MAX_LENGTH = 255;
const DEDUCTION_TYPE_KEY_PATTERN = /^[A-Z]+(-[A-Z]+)*$/;
const DEDUCTION_TYPE_KEY_FORMAT_MESSAGE =
  "Only uppercase letters and hyphens are allowed";

function getMutationErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message.trim() : "";
}

export function isDeductionTypeKeyDuplicateError(error: unknown): boolean {
  const normalized = getMutationErrorMessage(error).toLowerCase();
  return (
    normalized.includes("deduction type key") ||
    normalized.includes("duplicate") ||
    normalized.includes("already exists")
  );
}

export function generateDeductionTypeKeyFromName(name: string): string {
  return generateEntityKey(
    name,
    DEDUCTION_TYPE_KEY_CHARS,
    DEDUCTION_TYPE_KEY_MAX_LENGTH,
  );
}

export function createDeductionTypeKeyRules() {
  return [
    { required: true, message: "Deduction type key is required" },
    {
      pattern: DEDUCTION_TYPE_KEY_PATTERN,
      message: DEDUCTION_TYPE_KEY_FORMAT_MESSAGE,
    },
    {
      max: DEDUCTION_TYPE_KEY_MAX_LENGTH,
      message: `Deduction type key must be less than or equal to ${DEDUCTION_TYPE_KEY_MAX_LENGTH} characters.`,
    },
  ];
}
